import type { ApiModuleEndpoints } from '../types'

export const salesAreaApiEndpoints = {
  list: {
    method: 'GET',
    path: '/sales-areas',
    requiresAuth: true,
  },
  options: {
    method: 'GET',
    path: '/sales-areas/options',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/sales-areas/:id',
    requiresAuth: true,
  },
  create: {
    method: 'POST',
    path: '/sales-areas',
    requiresAuth: true,
  },
  importTemplate: {
    method: 'GET',
    path: '/sales-areas/import-template',
    requiresAuth: true,
  },
  importCatalogs: {
    method: 'GET',
    path: '/sales-areas/import-catalogs',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/sales-areas/:id',
    requiresAuth: true,
  },
  delete: {
    method: 'DELETE',
    path: '/sales-areas/:id',
    requiresAuth: true,
  },
  restore: {
    method: 'POST',
    path: '/sales-areas/:id/restore',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
